import { createContext, useReducer } from 'react';

export const ModalContext = createContext();

const initialState = {
  isOpen: false,
	modalName: null,
  modalParams: null,
};

const modalReducer = (state, action) => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return {
        isOpen: true,
				modalName: action.name,
        modalParams: action.payload,
      };
    case 'CLOSE_MODAL':
      return {
        isOpen: false,
        modalName: null,
        modalParams: null,
      };
    default:
      return state;
  }
};

// Провайдер контекста
export const ModalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(modalReducer, initialState);

  return (
    <ModalContext.Provider value={{ state, dispatch }}>
      {children}
    </ModalContext.Provider>
  );
};